export const POS_MODULE_LOADED_MESSAGE = 'POS.MODULE.LOADED';
export type PosModuleLoadedMessage = {
  message: string;
  module: string;
};

export const createModuleLoadedMessage = (
  module: string
): PosModuleLoadedMessage => {
  return {
    message: POS_MODULE_LOADED_MESSAGE,
    module: module,
  };
};
